export const reduxKey = '@@Writer';
export const READING_SPEED = 200; // wpm
